const doc = [({"en":({"adminConstantRoomPlanDisplayType":({"default":"Default", "noImage":"No plan image", "onlyOne":"Only one", "onlyPlan":"Only plan"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;